<template>
    <div>
        <van-dialog class="vip-dialog" v-model="visible" :title="''" :show-cancel-button="false"
            :show-confirm-button="false" :close-on-click-overlay="closeOnClickOverlay" @close="handleClose">
            <div class="dialog-content">
                <img :src="imageSrc" alt="vip-dialog" class="vip-dialog-img" />
            </div>
            <div class="vip-footer">
                <van-button type="primary" round
                    color="linear-gradient(90deg, rgba(149, 138, 242, 1) 3.85%, rgba(78, 128, 238, 1) 47.6%, rgba(111, 168, 247, 1) 100%)"
                    block @click="handleConfirm">{{ confirmText }}</van-button>
                <p class="vip-agreement">
                    点击"{{ confirmText }}"，即表示您同意<br />
                    <span class="agreement-link" @click="handleAgreement">《隐私政策与用户服务协议》</span>
                </p>
            </div>
        </van-dialog>

        <!-- 领取成功弹窗 -->
        <div v-if="showSuccessModal" class="vip-success-modal-overlay" @click="closeSuccessModal">
            <div class="vip-success-modal" @click.stop>
                <div class="modal-content">
                    <div class="modal-title">领取成功</div>
                    <div class="modal-success-text">您已成功领取"90天"VIP会员体验</div>
                    <div class="modal-row">
                        <span class="modal-label">会员有效期至：</span>
                        <span class="modal-value">{{ vipExpireDate }}</span>
                    </div>
                    <div class="modal-row">
                        <span class="modal-label">会员状态：</span>
                        <span class="modal-value status">已激活</span>
                    </div>
                </div>
                <div class="modal-btn" @click="closeSuccessModal">立即体验</div>
            </div>
        </div>
    </div>
</template>

<script>
import defaultImage from "@/assets/img/home/title.png";
import { getPlus } from "@/api/home";
import store from "@/store";

export default {
    name: "VipDialog",
    computed: {
        // 兼容未注入 $store 的场景，直接从全局 store 读取
        vipPackage() {
            const currentStore = store;
            if (currentStore && currentStore.getters) {
                return currentStore.getters.vipPackage || [];
            }
            return [];
        },
    },
    watch: {
        vipPackage: {
            handler(newVal) {
                // 从 store 中获取 VIP 信息
                if (newVal && newVal.length > 0) {
                    const vipInfo = newVal[0];
                    
                    // 从 vipPackage 中获取有效期
                    if (vipInfo.endDate) {
                        this.vipExpireDate = this.formatDate(vipInfo.endDate);
                    } else {
                        // 如果没有有效期，使用默认值（90天后的日期）
                        const expireDate = new Date();
                        expireDate.setDate(expireDate.getDate() + 90);
                        this.vipExpireDate = this.formatDate(expireDate);
                    }
                } else {
                    // 如果 store 中没有 VIP 信息，使用默认值（90天后的日期）
                    const expireDate = new Date();
                    expireDate.setDate(expireDate.getDate() + 90);
                    this.vipExpireDate = this.formatDate(expireDate);
                }
            },
            immediate: true, // 立即执行一次
            deep: true, // 深度监听
        },
    },
    data() {
        return {
            visible: false,
            imageSrc: defaultImage,
            confirmText: "立即领取",
            closeOnClickOverlay: true,
            resolver: null,
            reShowOnBack: false,
            showSuccessModal: false, // 显示领取成功弹窗
            vipExpireDate: "", // VIP有效期
        };
    },
    methods: {
        /**
         * 以编程方式打开弹窗
         * @param {Object} options
         * @param {string} options.image 自定义图片地址
         * @param {string} options.confirmText 自定义确认按钮文案
         * @param {boolean} options.closeOnClickOverlay 是否点击遮罩关闭
         * @returns {Promise<"confirm"|"close">}
         */
        open(options = {}) {
            console.log("vipdialog",this.vipPackage)
            const { image, confirmText, closeOnClickOverlay = true } = options;
            this.imageSrc = image || defaultImage;
            this.confirmText = confirmText || "立即领取";
            this.closeOnClickOverlay = closeOnClickOverlay;
            this.reShowOnBack = false; // 重置导航恢复标记
            this.visible = true;
            return new Promise((resolve) => {
                this.resolver = resolve;
            });
        },
        close() {
            if (this.visible) {
                this.visible = false;
            }
            this.emitAndClear("close");
        },
        async handleConfirm() {
            try {
                const res = await getPlus();
                if (res && (res.success || res.code === 200)) {
                    // 关闭原弹窗
                    this.visible = false;
                    this.emitAndClear("confirm");
                    
                    // 先刷新用户信息（包括 VIP 信息）
                    try {
                        await store.dispatch("GetProfile");
                    } catch (profileErr) {
                        console.error("刷新用户信息失败:", profileErr);
                    }

                    this.showSuccessModal = true;
                } else {
                    this.$toast({
                        message: (res && res.msg) || "领取失败，请稍后重试",
                        duration: 1500,
                    });
                    this.visible = false;
                    this.emitAndClear("confirm");
                }
            } catch (err) {
                this.$toast({
                    message: "领取失败，请检查网络后重试",
                    duration: 1500,
                });
                this.visible = false;
                this.emitAndClear("confirm");
            }
        },
        formatDate(date) {
            // 格式化日期为 YYYY-MM-DD
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        closeSuccessModal() {
            this.showSuccessModal = false;
            // 延迟刷新页面
            setTimeout(() => {
                window.location.reload();
            }, 300);
        },
        handleAgreement() {
            // 跳转到用户协议页面，临时隐藏弹窗，返回后再恢复
            this.reShowOnBack = true;
            this.hideForNavigation();
            this.$router.push({ name: "agreement" });
        },
        hideForNavigation() {
            // 仅隐藏，不触发关闭回调
            this.visible = false;
        },
        restoreIfNeeded(to) {
            // 路由返回时恢复弹窗显示
            if (this.reShowOnBack && to.name !== "agreement") {
                this.visible = true;
                this.reShowOnBack = false;
            }
        },
        handleClose() {
            this.visible = false;
            this.emitAndClear("close");
        },
        emitAndClear(type) {
            if (this.resolver) {
                this.resolver(type);
                this.resolver = null;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.vip-dialog {
    font-size: 0;
    background-color: transparent;
    padding: 0;
    font-family: "普惠_2.0_medium" , sans-serif;
}

.dialog-content {
    text-align: center;
}

.vip-dialog-img {
    width: 100%;
    height: auto;
    display: block;
}

.vip-footer {
    position: absolute;
    width: 100%;
    transform: translateY(-100%);
    background: transparent;
    padding: 12px 16px 20px;
    box-sizing: border-box;
}

.vip-agreement {
    margin: 8px 0 0;
    font-size: 12px;
    color: black;
    line-height: 1.4;
    text-align: center;
}

.agreement-link {
    color: #076bf2;
}

/* 领取成功弹窗样式 */
.vip-success-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
}

.vip-success-modal {
    width: 330px;
    height: 275px;
    background: url('@/assets/img/v1-1/bg-vip-modal.png') no-repeat;
    background-size: contain;
    background-position: center;
    border-radius: 16px;
    // padding: 40px 20px 20px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.vip-success-modal .modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    margin-top: 110px;
    padding: 0 18px;
    box-sizing: border-box;
}

.modal-title {
    font-size: 22px;
    font-weight: 500;
    color: #000;
    text-align: center;
    margin-bottom: 7px;
}

.modal-success-text {
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
    color: #000;
    text-align: center;
    line-height: 1.4;
    padding: 4px 0;
    margin-bottom: 10px;
    z-index: 1;
}

.modal-success-text::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, #938AEB 0%, #7BA6F1 100%);
    border-radius: 4px;
    opacity: 0.4;
    z-index: 0;
    height: 8px;
    transform: translateY(200%);
}

.modal-row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 400;
    color: #374151;
    line-height: 1.4;
    margin-bottom: 10px;
    padding: 0 10px;
    box-sizing: border-box;
}

.modal-row:last-child {
    margin-bottom: 30px;
}

.modal-label {
    color: #374151;
    font-weight: 400;
    font-size: 12px;
}

.modal-value {
    color: #374151;
    font-weight: 500;
    font-size: 12px;
}

.modal-value.status {
    color: #5B54E4;
}

.vip-success-modal .modal-btn {
    position: absolute;
    bottom: 10px;
    width: 120px;
    height: 34px;
    box-shadow:inset 0px 0px 10px  #FFFFFFFF,inset 0px 5px 10px  #52A3F8FF, 0px 2px 6px  #52A3F8FF;
    background: linear-gradient(90deg, #958AF2 3.85%, #4E80EE 47.6%, #6FA8F7 100%);
    border: 2px solid #BFDEFFFF;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
}

.vip-success-modal .modal-btn:active {
    opacity: 0.8;
    transform: scale(0.98);
}
</style>
